import { ColumnsType } from 'antd/es/table/Table';
import { IDonorRecord } from 'modules/dashboard/types/donor';

import { COLUMN_REGISTRY } from './columnRegistry';

import { ColumnBuildContext, ColumnKey } from '../types';

export function buildColumns(
  keys: ColumnKey[],
  ctx: ColumnBuildContext
): ColumnsType<IDonorRecord> {
  return keys.map((key) => COLUMN_REGISTRY[key].buildTableColumn(ctx));
}
